<template>
    <div v-if="shouldShowMessage || shouldShowRanges" :class="['progressive-discount-notice', {'has-ranges': shouldShowRanges}]">
        <div v-if="shouldShowMessage" class="progressive-discount-message">
            <i class="fas fa-tag"></i>
            <span>{{ message }}</span>
        </div>
        <div v-if="shouldShowRanges" class="progressive-discount-table">
            <div class="progressive-discount-title">Tabela de desconto progressivo</div>
            <div class="progressive-discount-ranges">
                <div
                    v-for="range in notice.ranges"
                    :key="range.id"
                    :class="['progressive-discount-range', {'is-current': range.is_current, 'is-reached': range.is_reached}]"
                >
                    <span class="range-amount">{{ formatRange(range) }}</span>
                    <strong>{{ formatPercent(range.percentage) }}</strong>
                    <small v-if="range.is_current">Faixa atual</small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Currency from '../../helpers/parseCurrency'

export default {
    name: 'ProgressiveDiscountNotice',
    props: {
        notice: {
            default: null
        },
        showRanges: {
            type: Boolean,
            default: false
        },
        showMessage: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            currency: Currency
        }
    },
    computed: {
        message() {
            if (!this.notice || !this.notice.type) {
                return null
            }

            if (this.notice.type === 'next') {
                return `Por mais ${this.currency.money(this.notice.amount_to_next)}, você ganha ${this.formatPercent(this.notice.next_percentage)} de desconto especial.`
            }

            if (this.notice.type === 'upgrade') {
                return `Você ganhou ${this.formatPercent(this.notice.current_percentage)} de desconto especial. Adicione mais ${this.currency.money(this.notice.amount_to_next)} em produtos para alcançar a próxima faixa.`
            }

            if (this.notice.type === 'max') {
                return `Você ganhou ${this.formatPercent(this.notice.current_percentage)} de desconto especial neste pedido.`
            }

            return null
        },
        hasRanges() {
            return !!(this.notice && this.notice.ranges && this.notice.ranges.length)
        },
        shouldShowMessage() {
            return this.showMessage && !!this.message
        },
        shouldShowRanges() {
            return this.showRanges && this.hasRanges
        }
    },
    methods: {
        formatMoney(value) {
            return this.currency.money(value)
        },
        formatRange(range) {
            if (!range.final_amount) {
                return `Compras acima de ${this.formatMoney(range.initial_amount)}`
            }

            return `Compras acima de ${this.formatMoney(range.initial_amount)}\naté ${this.formatMoney(range.final_amount)}`
        },
        formatPercent(value) {
            const percent = Number(value || 0)
            return `${percent.toLocaleString('pt-BR', {
                minimumFractionDigits: percent % 1 === 0 ? 0 : 2,
                maximumFractionDigits: 2
            })}%`
        }
    }
}
</script>

<style scoped>
.progressive-discount-notice {
    background: #f6fff3;
    border: 1px solid #cdecc6;
    color: #315d2c;
    font-size: 1.4rem;
    line-height: 1.35;
    margin: 0 0 1.5rem;
    padding: 1.1rem 1.4rem;
}

.progressive-discount-message {
    align-items: center;
    display: flex;
    gap: .8rem;
}

.progressive-discount-message i {
    color: #4f9a43;
    flex: 0 0 auto;
}

.progressive-discount-notice.has-ranges {
    margin: 1.5rem 0 2.5rem;
}

.progressive-discount-table {
    margin-top: 1rem;
}

.progressive-discount-table:first-child {
    margin-top: 0;
}

.progressive-discount-title {
    color: #243f22;
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: .8rem;
}

.progressive-discount-ranges {
    display: grid;
    gap: .8rem;
    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
}

.progressive-discount-range {
    background: #fff;
    border: 1px solid #d9e8d5;
    display: flex;
    flex-direction: column;
    gap: .3rem;
    min-height: 8.4rem;
    padding: 1rem;
}

.progressive-discount-range.is-reached {
    border-color: #8bc27c;
}

.progressive-discount-range.is-current {
    background: #edf8ea;
    border-color: #4f9a43;
}

.progressive-discount-range strong {
    color: #243f22;
    font-size: 2rem;
}

.progressive-discount-range small {
    color: #315d2c;
    font-weight: 700;
}

.range-amount {
    color: #405d3d;
    font-size: 1.25rem;
    white-space: pre-line;
}
</style>
